import { CommonModule as NgCommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { CoreContentModule } from "@obg/ngx.core.content";

import { OverlaySpinnerComponent } from "./overlay-spinner.component";

const DIRECTIVES: any[] = [OverlaySpinnerComponent];

@NgModule({
	imports: [NgCommonModule, CoreContentModule, MatProgressSpinnerModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class OverlaySpinnerModule {}
